export default {
    data() {
      //手机号验证方法
      var validatePhone = (rule, value, callback) => {
        if (value == "") {
          callback(new Error(this.$t("register.enterPhoneNum")));
        } else if (!/^1(3|4|5|7|8|6|9)\d{9}$/.test(value)) {
          callback(this.$t("register.worngPhoneNum"));
        } else {
          this.$http
            .get(globalProvider.serviceUrl("ea/tt/md/p/ck/rg/") + escape(value), {
              headers: {
                ttoken: this.captcha_token
              }
            })
            .then(data => {
              if (data.body.code == resultCode.Success) {
                if (data.body.data == true) {
                  callback();
                } else {
                  callback(new Error(this.$t("findPwd.noBindPhone")));
                }
              }
            });
        }
      };
      //邮箱验证方法
      var validateEmail = (rule, value, callback) => {
        if (value == "") {
          callback(new Error(this.$t("register.enterEmail")));
        } else if (
          !this.$common.validEmail(value)
        ) {
          callback(new Error(this.$t("register.worngEmail")));
        } else {
          this.$http
            .get(globalProvider.serviceUrl("ea/tt/md/p/ck/rg/") + escape(value), {
              headers: {
                ttoken: this.captcha_token
              }
            })
            .then(data => {
              if (data.body.code == resultCode.Success) {
                if (data.body.data == true) {
                  callback();
                } else {
                  callback(new Error(this.$t("findPwd.noBindEmail")));
                }
              }
            });
        }
      };
      var validatePhonePass = (rule, value, callback) => {
        if (value == "") {
          callback(new Error(this.$t("message.inputPwd")));
        } else if (!/^[a-zA-Z\d]{6,26}$/.test(value)) {
          callback(new Error(this.$t("register.pwdlimit")));
        } else {
          if (this.phoneFindPwd_Form.phone_c_pwd !== "") {
            this.$refs.phoneFindPwd_Form.validateField("phone_c_pwd");
          }
          callback();
        }
      };
      var validatePhonePass2 = (rule, value, callback) => {
        if (value == "") {
          callback(new Error(this.$t("register.confirmPwdAgain")));
        } else if (value != this.phoneFindPwd_Form.phone_pwd) {
          callback(new Error(this.$t("register.confirmPwdWrong")));
        } else {
          callback();
        }
      };
      var validateEmailPass = (rule, value, callback) => {
        if (value == "") {
          callback(new Error(this.$t("message.inputPwd")));
        } else if (!/^[a-zA-Z\d]{6,26}$/.test(value)) {
          callback(new Error(this.$t("register.pwdlimit")));
        } else {
          if (this.emailFindPwd_Form.email_c_pwd !== "") {
            this.$refs.emailFindPwd_Form.validateField("email_c_pwd");
          }
          callback();
        }
      };
      var validateEmailPass2 = (rule, value, callback) => {
        if (value == "") {
          callback(new Error(this.$t("register.confirmPwdAgain")));
        } else if (value != this.emailFindPwd_Form.email_pwd) {
          callback(new Error(this.$t("register.confirmPwdWrong")));
        } else {
          callback();
        }
      };
      var validateCaptcha = (rule, value, callback) => {
        if (this.error_msg == "EA_ASA_CDC_02") {
          callback(new Error(getErrorMessage(this.error_msg)));
          this.error_msg = "";
        } else {
          callback();
        }
      };
      var validateDonCaptcha = (rule, value, callback) => {
        if (this.error_msg == "EA_ASA_RP_02") {
          callback(new Error(getErrorMessage(this.error_msg)));
          this.error_msg = "";
        } else {
          callback();
        }
      };
      return {
        find_way: "1",
        offsetHeight: document.body.offsetHeight,
        domain: "",
        batchCode:"",
        captcha_token: "",
        captchaUrl: "",
        findPwd_way: true,
        error_msg: "",
        error_display: false,
        error_message: "",
        pb_disabled: false,
        pb_show: this.$t("message.getVerificationCode"),
        email_pb_disabled: false,
        email_pb_show: this.$t("message.getVerificationCode"),
        emailFindDisable: false,
        phoneFindDisable: false,
        phoneFindPwd_Form: {
          phone: "",
          captcha: "",
          phone_captcha: "",
          phone_pwd: "",
          phone_c_pwd: ""
        },
        phoneFindPwd_Form_rules: {
          phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
          captcha: [
            { required: false, validator: validateCaptcha, trigger: "change" }
          ],
          phone_captcha: [
            { required: true, message: this.$t("common.enterCode"), trigger: "change" },
            { validator: validateDonCaptcha, trigger: "change" }
          ],
          phone_pwd: [
            { required: true, validator: validatePhonePass, trigger: "blur" }
          ],
          phone_c_pwd: [
            { required: true, validator: validatePhonePass2, trigger: "blur" }
          ]
        },
        emailFindPwd_Form: {
          email: "",
          captcha: "",
          email_captcha: "",
          email_pwd: "",
          email_c_pwd: ""
        },
        emailFindPwd_Form_rules: {
          email: [{ required: true, validator: validateEmail, trigger: "blur" }],
          captcha: [
            { required: false, validator: validateCaptcha, trigger: "change" }
          ],
          email_captcha: [
            { required: true, message:this.$t("common.enterCode"), trigger: "change" },
            { validator: validateDonCaptcha, trigger: "change" }
          ],
          email_pwd: [
            { required: true, validator: validateEmailPass, trigger: "blur" }
          ],
          email_c_pwd: [
            { required: true, validator: validateEmailPass2, trigger: "blur" }
          ]
        }
      };
    },
    created: function() {
      this.get_captcha_token();
      this.$store.commit("setHeaderState", "100");
      window.addEventListener("resize", this.handleResize);
      this.handleResize();
      this.domain = this.$store.state.examInfo.currentExamInfo.domain;
      this.batchCode = this.$store.state.examInfo.currentExamInfo.batchCode;
    },
    watch: {
      find_way(val) {
        this.get_captcha_token();
        this.error_msg = "";
        this.error_display = false;
        if (val == 1) {
          this.$refs["emailFindPwd_Form"].resetFields();
        }
        if (val == 2) {
          this.$refs["phoneFindPwd_Form"].resetFields();
        }
      }
    },
    methods: {
      handleResize(event) {
        this.offsetHeight = document.body.offsetHeight-100;
      },
      onM2ChangeFindPwdWay: function() {},
      //更改修改密码方式
      onChangeFindPwdWay: function(e) {
        let el = e.currentTarget;
        if (el.getAttribute("index") !== this.findPwd_way) {
          this.findPwd_way = !this.findPwd_way;
          this.get_captcha_token();
        }
        this.error_msg = "";
        this.error_display = false;
        if (this.$refs.phoneFindPwd_Form)
          this.$refs.phoneFindPwd_Form.resetFields();
        if (this.$refs.emailFindPwd_Form)
          this.$refs.emailFindPwd_Form.resetFields();
      },
      //获取临时token，并且获取图片
      get_captcha_token: function() {
        this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
          if (data.body.code === resultCode.Success) {
            this.captcha_token = data.body.data;
            this.captchaUrl = serviceUrl + "ea/tt/vc/" + this.captcha_token;
          } else {
            this.$alert(data.body.msg, this.$t("common.tip"), {
              confirmButtonText: this.$t("common.confirm"),
              callback: function(action) {
                console.log("OK");
              }
            });
          }
        });
      },
      //仅仅获取临时token
      set_captcha_token: function() {
        this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
          if (data.body.code == resultCode.Success) {
            this.captcha_token = data.body.data;
          } else {
            this.$alert(data.body.msg, this.$t("common.tip"), {
              confirmButtonText: this.$t("common.confirm"),
              callback: function(action) {
                console.log("OK");
              }
            });
          }
        });
      },
      //手机修改密码提交
      onPhoneSubmit: function(formName) {
        this.phoneFindDisable = true;
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$http
              .post(
                globalProvider.serviceUrl("ea/tt/md/p/m"),
                {
                  ac: this.phoneFindPwd_Form.phone,
                  dc: this.phoneFindPwd_Form.phone_captcha,
                  n_p: this.phoneFindPwd_Form.phone_pwd,
                  c_p: this.phoneFindPwd_Form.phone_c_pwd
                },
                {
                  headers: {
                    ttoken: this.captcha_token
                  },
                  emulateJSON: false
                }
              )
              .then(data => {
                this.phoneFindDisable = false;
                if (data.body.code == resultCode.Success) {
                  this.$alert(this.$t("findPwd.changePwdSuccess"), this.$t("common.tip"), {
                    confirmButtonText: this.$t("common.confirm"),
                    callback: action => {
                      this.$router.push({
                        name: "main",
                        params: { projectCode: this.domain }
                      });
                    }
                  });
                } else if (data.body.code == resultCode.NotSuccess) {
                  if (data.body.message == "EA_ASA_RP_01") {
                    this.error_display = true;
                    this.error_message = getErrorMessage(data.body.message);
                  } else {
                    this.error_msg = data.body.message;
                    this.$refs.phoneFindPwd_Form.validateField("phone_captcha");
                  }
                }
              });
          } else {
            this.phoneFindDisable = false;
            return false;
          }
        });
      },
      //获取手机动态码
      fpw_onGetPhoneCaptcha: function() {
        this.$refs.phoneFindPwd_Form.validateField("phone", valid => {
          if (valid == "") {
            if (this.phoneFindPwd_Form.captcha != "") {
              this.$http
                .get(
                  globalProvider.serviceUrl("ea/tt/g/mpdc/m/ts/") +
                    escape(this.phoneFindPwd_Form.phone),
                  {
                    headers: {
                      ttoken: this.captcha_token
                    }
                  }
                )
                .then(data => {
                  if (data.body.code == resultCode.Success) {
                    if (data.body.data < 60 && data.body.data > 0) {
                      this.pb_disabled = true;
                      let time = 60 - data.body.data;
                      this.pb_show = 60 - data.body.data + 1;
                      for (let i = 0; i <= time; i++) {
                        window.setTimeout(() => {
                          --this.pb_show;
                          if (this.pb_show == 0) {
                            this.pb_show =this.$t("message.getVerificationCode");
                            this.pb_disabled = false;
                          }
                        }, i * 1000);
                      }
                    } else {
                      this.$http
                        .post(
                          globalProvider.serviceUrl("ea/tt/c/mpdc/m"),
                          {
                            mb: this.phoneFindPwd_Form.phone,
                            vc: this.phoneFindPwd_Form.captcha,
                            kv: {
                              考试名称: this.$store.state.examInfo.currentExamInfo
                                .exam_name
                            }
                          },
                          {
                            headers: {
                              ttoken: this.captcha_token
                            },
                            emulateJSON: false
                          }
                        )
                        .then(data => {
                          if (data.body.code == resultCode.Success) {
                            this.set_captcha_token();
                            this.pb_disabled = true;
                            let time = 60;
                            this.pb_show = time + 1;
                            for (let i = 0; i <= time; i++) {
                              window.setTimeout(() => {
                                --this.pb_show;
                                if (this.pb_show == 0) {
                                  this.pb_show = this.$t("message.reSend");
                                  this.pb_disabled = false;
                                  this.captchaUrl =
                                    serviceUrl + "ea/tt/vc/" + this.captcha_token;
                                }
                              }, i * 1000);
                            }
                          } else if (data.body.code == resultCode.NotSuccess) {
                            this.get_captcha_token();
                            if (data.body.message == "EA_ASA_CDC_01") {
                              this.error_display = true;
                              this.error_message = getErrorMessage(
                                data.body.message
                              );
                            } else {
                              this.error_msg = data.body.message;
                              this.$refs.phoneFindPwd_Form.validateField(
                                "captcha"
                              );
                            }
                          } else {
                            this.get_captcha_token();
                          }
                        });
                    }
                  } else if (data.body.code == resultCode.NotSuccess) {
                    this.error_display = true;
                    this.error_message = getErrorMessage(data.body.message);
                  }
                });
            } else {
              return false;
            }
          }
        });
      },
      //邮箱修改密码提交
      onEmailSubmit: function(formName) {
        this.emailFindDisable = true;
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$http
              .post(
                globalProvider.serviceUrl("ea/tt/md/p/e"),
                {
                  ac: this.emailFindPwd_Form.email,
                  dc: this.emailFindPwd_Form.email_captcha,
                  n_p: this.emailFindPwd_Form.email_pwd,
                  c_p: this.emailFindPwd_Form.email_c_pwd
                },
                {
                  headers: {
                    ttoken: this.captcha_token
                  },
                  emulateJSON: false
                }
              )
              .then(data => {
                this.emailFindDisable = false;
                if (data.body.code == resultCode.Success) {
                  this.$alert(this.$t("findPwd.changePwdSuccess"), this.$t("common.tip"), {
                    confirmButtonText: this.$t("common.confirm"),
                    callback: function(action) {
                      this.$router.push({
                        name: "main",
                        params: { projectCode: this.domain }
                      });
                    }
                  });
                } else if (data.body.code == resultCode.NotSuccess) {
                  if (data.body.message == "EA_ASA_RP_01") {
                    this.error_display = true;
                    this.error_message = getErrorMessage(data.body.message);
                  } else {
                    this.error_msg = data.body.message;
                    this.$refs.emailFindPwd_Form.validateField("email_captcha");
                  }
                }
              });
          } else {
            this.emailFindDisable = false;
            return false;
          }
        });
      },
      //获取邮箱动态码
      fpw_onGetEmailCaptcha: function() {
        this.$refs.emailFindPwd_Form.validateField("email", valid => {
          if (valid == "") {
            if (this.emailFindPwd_Form.captcha != "") {
              this.$http
                .get(
                  globalProvider.serviceUrl("ea/tt/g/mpdc/e/ts/") +
                    escape(this.emailFindPwd_Form.email),
                  {
                    headers: {
                      ttoken: this.captcha_token
                    }
                  }
                )
                .then(data => {
                  if (data.body.code == resultCode.Success) {
                    if (data.body.data < 60 && data.body.data > 0) {
                      this.email_pb_disabled = true;
                      let time = 60 - data.body.data;
                      this.email_pb_show = 60 - data.body.data + 1;
                      for (let i = 0; i <= time; i++) {
                        window.setTimeout(() => {
                          --this.email_pb_show;
                          if (this.email_pb_show == 0) {
                            this.email_pb_show = this.$t("message.getVerificationCode");
                            this.email_pb_disabled = false;
                          }
                        }, i * 1000);
                      }
                    } else {
                      this.$http
                        .post(
                          globalProvider.serviceUrl("ea/tt/c/mpdc/e"),
                          {
                            em: this.emailFindPwd_Form.email,
                            vc: this.emailFindPwd_Form.captcha
                          },
                          {
                            headers: {
                              ttoken: this.captcha_token
                            },
                            emulateJSON: false
                          }
                        )
                        .then(data => {
                          if (data.body.code == resultCode.Success) {
                            this.set_captcha_token();
                            this.email_pb_disabled = true;
                            let time = 60;
                            this.email_pb_show = time + 1;
                            for (let i = 0; i <= time; i++) {
                              window.setTimeout(() => {
                                --this.email_pb_show;
                                if (this.email_pb_show == 0) {
                                  this.email_pb_show = this.$t("message.reSend");
                                  this.email_pb_disabled = false;
                                  this.captchaUrl =
                                    serviceUrl + "ea/tt/vc/" + this.captcha_token;
                                }
                              }, i * 1000);
                            }
                          } else if (data.body.code == resultCode.NotSuccess) {
                            this.get_captcha_token();
                            if (data.body.message == "EA_ASA_CDC_01") {
                              this.error_display = true;
                              this.error_message = getErrorMessage(
                                data.body.message
                              );
                            } else {
                              this.error_msg = data.body.message;
                              this.$refs.emailFindPwd_Form.validateField(
                                "captcha"
                              );
                            }
                          } else {
                            this.get_captcha_token();
                          }
                        });
                    }
                  } else {
                    this.$alert(data.body.message,  this.$t("common.tip"), {
                      confirmButtonText: this.$t("common.confirm"),
                      callback: function(action) {
                        console.log("OK");
                      }
                    });
                  }
                });
            } else if (data.body.code == resultCode.NotSuccess) {
              this.error_display = true;
              this.error_message = getErrorMessage(data.body.message);
            }
          } else {
            return false;
          }
        });
      }
    }
  };